import { defineComponent } from "bitecs";
import { Vector3 } from "./Vector3";

export const MovementGoalComponent = defineComponent(Vector3);
